import { default as disableWebPushNotifications } from './disableWebPushNotifications';
import { getUserPreferenceIdentifier } from './utils/getUserPreferenceIdentifier';
import { WebPushNotificationsOptions } from 'owa-outlook-service-options';
import {
    updateLocalWebPushEnabledStatus,
    cleanupLocalWebpushUserSetting,
} from './localWebPushUserSettingActions';

export async function userInitiatedWebPushDisableWorkflow(
    windowObj: Window,
    webPushNotificationsOptions: WebPushNotificationsOptions,
    mbxGuid: string,
    disableAllClients: boolean
): Promise<boolean> {
    let userPreferenceIdentifier = getUserPreferenceIdentifier(
        mbxGuid,
        webPushNotificationsOptions
    );

    if (disableAllClients) {
        cleanupLocalWebpushUserSetting(windowObj, userPreferenceIdentifier);
    } else {
        updateLocalWebPushEnabledStatus(windowObj, false, userPreferenceIdentifier);
    }

    return disableWebPushNotifications(windowObj);
}
